<template>
    <div>
        <div class="card">
            <div class="card-block">
                <h4 class="card-title">
                    {{$t('COMMON.price')}} Id: {{price.id}}
                </h4>
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    {{$t('COMMON.price')}}: {{price.price}} €
                </li>
                <li class="list-group-item">
                    {{$t('PRICES.assignedProduct')}} {{price.product}}
                </li>
            </ul>
            <div class="card-block">
                <a class="card-link edit-link" name="edit"
                   @click="editPrice(price)" v-if="$isAllowed('update')">
                    {{$t('UI.edit')}}
                </a>
                <a class="card-link delete-link" name="delete"
                   @click="$emit('remove', price)" v-if="$isAllowed('destroy')">
                    {{$t('UI.delete')}}
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from 'vuex';
import { PricesPerimeter } from '../../../router/perimeters/pricesPerimeter';

export default {
    data () {
        return {};
    },
    computed: {
        ...mapGetters({
            products: 'getProducts'
        })
    },
    props: ['price'],
    perimeters: [
        PricesPerimeter
    ],
    methods: {
        ...mapActions([
            'getPricesAsync',
            'confirmAction'
        ]),
        editPrice (price) {
            this.$emit('editPrice', price);
        }
    }
};
</script>
